import React, { useState } from "react";
import chevronUp from "../../../../assets/images/icons/chevron-up.svg";
import chevronDown from "../../../../assets/images/icons/chevron-down.svg";
import SVGWrapper from "../../../Components/SVGWrapper";

export const Faq = ({ title, items }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  if (!items) return null;

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="my-8">
      {title && (
        <h2 className="text-2xl font-bold mb-6 text-jay-blue">{title}</h2>
      )}
      {items.map((item, index) => (
        <div key={index} className="mb-2 border border-[#A6A8AB]">
          <button
            onClick={() => toggleAccordion(index)}
            className={`w-full text-left py-4 px-8 flex justify-between gap-8 items-center focus:outline-none bg-[#F6F6F6] ${activeIndex === index ? "border-b border-[#A6A8AB]" : ""}`}
          >
            <h3 className="text-lg font-bold m-0">{item.question}</h3>
            <span className="shrink-0">
              {activeIndex === index ? (
                <SVGWrapper src={chevronUp} />
              ) : (
                <SVGWrapper src={chevronDown} />
              )}
            </span>
          </button>
          {activeIndex === index && (
            <div className="py-4 px-8 text-base text-black">{item.answer}</div>
          )}
        </div>
      ))}
    </div>
  );
};
